export {
  /**
   * @deprecated - import from `@uploadthing/react` instead
   */
  generateReactHelpers,
} from "./useUploadThing";

export {
  /**
   * @deprecated - import from `@uploadthing/react` instead
   */
  useDropzone,
} from "@uploadthing/dropzone/react";
